import styled from 'styled-components';
import { ThemeColours } from '../styles/ThemeColours';
import { Link } from './Link';

export const StyledLink = styled(Link)`
  color: ${ThemeColours.primary500};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
